import c_table from "@/components/c_table"


export default [
    c_table
]